import React, { useState, useEffect } from 'react';
import { useNavigate, Navigate } from 'react-router-dom';
import '../../assets/css/home.css';
import clientImage from '../../assets/images/client.png';
import grapheImage from '../../assets/images/login_bg.jpg';
import brandLogo from '../../assets/images/Logo_animation.gif';
import { Button } from 'primereact/button';
import CryptoJS from 'crypto-js';

// Secret key for encryption/decryption
const SECRET_KEY = 'your-strong-secret-key';

// Decrypt data from localStorage
const decryptData = (encryptedData) => {
  if (!encryptedData) return null;
  try {
    const bytes = CryptoJS.AES.decrypt(encryptedData, SECRET_KEY);
    const decryptedString = bytes.toString(CryptoJS.enc.Utf8);
    return decryptedString ? JSON.parse(decryptedString) : null;
  } catch (error) {
    console.error('Decryption error:', error);
    return null;
  }
};

const Home = () => {
  const [redirectPath, setRedirectPath] = useState(null);
  const [transition, setTransition] = useState(''); // Manage transition state
  const navigate = useNavigate();

  const handleNavigation = (path, animationClass) => {
    setTransition(animationClass); // Set the animation class
    setTimeout(() => {
      navigate(path); // Navigate after animation
      setTransition(''); // Reset transition state
    }, 800); // Match the animation duration
  };


  useEffect(() => {
    const encryptedToken = localStorage.getItem('accessToken');
    const encryptedRole = localStorage.getItem('role');

    const token = decryptData(encryptedToken);
    const role = decryptData(encryptedRole);

    if (token && role) {
      if (role === 'Client') {
        setRedirectPath('/Client/dashboard');
      } else {
        switch (role) {
          case 'Admin':
          case 'SuperAdmin':
          case 'Founder':
            setRedirectPath('/Graphe/dashboard/Admin');
            break;
          case 'HumanResource':
            setRedirectPath('/Graphe/dashboard/Hr');
            break;
          case 'Accounts':
            setRedirectPath('/Graphe/dashboard/Accounts');
            break;
          case 'Department_Head':
          case 'Employee':
          case 'Social_Media_Manager':
          case 'Task_manager':
            setRedirectPath('/Graphe/dashboard/employee');
            break;
          case 'Ex_employee':
            setRedirectPath('/Graphe/dashboard/Ex_employee');
            break;
          case 'Unverified':
            setRedirectPath('/Graphe/newuser/Unverified');
            break;
          default:
            setRedirectPath('/');
        }
      }
    }
  }, []);

  if (redirectPath) {
    return <Navigate to={redirectPath} />;
  }


  return (
    <div className={`home-container ${transition}`}>
      {/* Left Image */}
      <div className="image-container left">
        <h2>
          <small className='fadeInDown'>Are You</small>
          <span className='fadeInUp'>Client</span>
        </h2>
        <Button
          label="CLICK HERE"
          icon="pi pi-arrow-right"
          severity='danger'
          iconPos="right"
          className='mt-4 fadeInUp text-white'
          onClick={() => handleNavigation('/Client/', 'slide-right')}
        />
        {/* {<img src={clientImage} alt="Client" className="image" />} */}
      </div>

      {/* Right Image */}
      <div className="image-container right">
        <h2>
          <small className='fadeInDown'>Are You</small>
          <span className='fadeInUp'>Employee</span>
        </h2>
        <Button
          label="CLICK HERE"
          icon="pi pi-arrow-right"
          severity='help'
          iconPos="right"
          className='mt-4 fadeInUp text-white'
          onClick={() => handleNavigation('/Graphe/Login', 'slide-left')}
        />
        {/* <img src={grapheImage} alt="Graphe" className="image" /> */}
      </div>
      <div className='brandLogo_home'>
        <img src={brandLogo} alt="Client" />
      </div>

      {/* Transition Overlay */}
      <div className={`transition-overlay ${transition}`} />
    </div>
  );
};

export default Home;